const primaryDomain = 'kseniaschnaider.com';
const targetCountryCode = 'UA';
const summerSalePath = '/collections/summer-sale';

async function getVisitorCountry() {
    try {
        const response = await fetch('https://ipinfo.io/json');
        const data = await response.json();
        console.log('Visitor Country:', data.country); // Debug: Log visitor's country code
        return data.country; // Get the country code from response
    } catch (error) {
        console.error('Error getting visitor country:', error);
        return null;
    }
}

async function redirectBasedOnCountry() {
    try {
        const visitorCountry = await getVisitorCountry();
        const currentHostname = window.location.hostname;
        const currentPath = window.location.pathname;

        // Determine the target URL based on the visitor's country and current path
        let targetURL = null;
        
        if (visitorCountry) {
            if (visitorCountry.toUpperCase() === targetCountryCode) {
                if (currentHostname !== `ua.${primaryDomain}`) {
                    targetURL = `https://ua.${primaryDomain}${currentPath}`;
                }
            } else {
                if (currentHostname === `ua.${primaryDomain}`) {
                    targetURL = `https://${primaryDomain}${currentPath}`;
                }
            }
        }

        // Redirect to the target URL if it's different from the current URL
        if (targetURL && (window.location.href !== targetURL)) {
            window.location.replace(targetURL);
        }
    } catch (error) {
        console.error('Error redirecting based on country:', error);
    }
}

document.addEventListener('DOMContentLoaded', redirectBasedOnCountry);

